// components/PageLayout.js
import React from "react";
import { Container, Button } from "react-bootstrap";
import styles from "./StickyPageLayout.module.css";
import ButtonElement from "../../Element/ButtonElement";

const StickyPageLayout = ({ title, children,
submitProps,listProps
}) => {
  return (
    <div className={styles.wrapper}>
      {/* Header */}
      <div className={styles.header}>
        <h5 className={styles.title}>{title}</h5>
        <div style={{display:'flex', gap:'10px'}}>
          {submitProps && <ButtonElement {...submitProps} />}
          {listProps && <ButtonElement {...listProps} />}          
        </div>
      </div>

      {/* Scrollable Content */}
      <div className={styles.content}>
        <Container fluid>{children}</Container>
      </div>
    </div>
  );
};

export default StickyPageLayout;